import React, {
	SetStateAction,
	useState,
	useLayoutEffect,
	useContext
} from 'react';
import { MdModeEdit, MdDelete, MdRemoveRedEye } from 'react-icons/md';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import * as S from './styles';
import { MenuItemLocationProps } from 'types/MenuItemLocationProps';
import Load from 'components/Load';
import { color } from 'styles/pallete';
import { UseTranslationProps } from 'types/UseTranslationProps';
import ConfirmScreen from 'components/ConfirmScreen';
import { listRoutes } from 'router/listRoutes';
import { deleteItemFromBd } from './reqs';
import SystemNotifyContext from 'context/SystemNotifyContext';
import LoadGeneralContext from 'context/LoadGeneralContext';
interface ListMenuItensLocationProps {
	isReq: boolean;
	setIsOpen: React.Dispatch<SetStateAction<boolean>>;
	setUserToEdit: React.Dispatch<SetStateAction<null | MenuItemLocationProps>>;
	listMenuItensLocation: MenuItemLocationProps[];
	setListMenuItensLocation: React.Dispatch<
		SetStateAction<MenuItemLocationProps[]>
	>;
}

export default function ListMenuItensLocation({
	isReq,
	setIsOpen,
	setUserToEdit,
	listMenuItensLocation,
	setListMenuItensLocation
}: ListMenuItensLocationProps) {
	const { t }: UseTranslationProps = useTranslation();
	const { handleNotify } = useContext(SystemNotifyContext);
	const { setIsOpenLoad } = useContext(LoadGeneralContext);

	const [isConfirmDelete, setIsConfirmDelete] = useState(false);
	const [itemToDelete, setItemToDelete] =
		useState<null | MenuItemLocationProps>(null);

	function edit(item: MenuItemLocationProps) {
		setUserToEdit(item);
		setIsOpen(true);
	}

	async function deleteItem() {
		if (itemToDelete != null) {
			setIsOpenLoad(true);
			const resp = await deleteItemFromBd(itemToDelete, handleNotify);
			setIsOpenLoad(false);

			if (resp) {
				const newList = listMenuItensLocation.filter(
					(item) => item.id !== itemToDelete.id
				);
				setListMenuItensLocation(newList);
				setIsConfirmDelete(false);
				setItemToDelete(null);
			}
		}
	}

	//reseta o setItemToDelete toda vez q a tela de confirmação é fechada
	useLayoutEffect(() => {
		if (!isConfirmDelete) {
			setItemToDelete(null);
		}
	}, [isConfirmDelete]);

	return (
		<S.container>
			{isReq ? (
				<S.centralize>
					<Load
						text={t('menuItensLocation.listMenuItensLocation.load')}
						showText
					/>
				</S.centralize>
			) : (
				<>
					{!isReq && listMenuItensLocation.length === 0 ? (
						<S.centralize>
							<S.noUsers>
								{t('menuItensLocation.listMenuItensLocation.noItens')}
							</S.noUsers>
						</S.centralize>
					) : (
						<>
							<S.header>
								<p>{t('menuItensLocation.listMenuItensLocation.page')}</p>
								<p>Slug</p>
								<p>{t('menuItensLocation.listMenuItensLocation.actions')}</p>
							</S.header>
							<S.line />
							<S.list>
								{listMenuItensLocation.map((item) => (
									<React.Fragment key={item.id}>
										<S.itemList>
											<p>{item.name}</p>
											<p>{item.slug}</p>
											<S.actions>
												<Link
													to={`${listRoutes.menuItensLocation}/${item.slug}`}
													key={item.id}
												>
													<MdRemoveRedEye
														size={25}
														color={color.interface.darkgray}
													/>
												</Link>

												<MdModeEdit
													size={25}
													color={color.interface.darkgray}
													onClick={() => {
														edit(item);
													}}
												/>
												<MdDelete
													size={25}
													color={color.interface.darkgray}
													onClick={() => {
														setItemToDelete(item);
														setIsConfirmDelete(true);
													}}
												/>
											</S.actions>
										</S.itemList>
										<S.line />
									</React.Fragment>
								))}
							</S.list>
						</>
					)}
				</>
			)}

			<ConfirmScreen
				setIsOpen={setIsConfirmDelete}
				isOpen={isConfirmDelete}
				title="dynamicShowCase.listDynamicShowCase.confirmation"
				message={
					<p>
						{t('menuItensLocation.listMenuItensLocation.confirmationText')}{' '}
						<b style={{ fontFamily: 'nunito-bold' }}>{itemToDelete?.name}</b>?
					</p>
				}
				buttonClose={false}
				functionToExecOnConfirm={deleteItem}
			/>
		</S.container>
	);
}
